import { createAction } from '@reduxjs/toolkit';
import GoogleAnalytics from 'api/google_analytics';
import {
  isBookingPaid,
  isPurchaseTracked,
  markPurchaseTracked,
} from 'utils/tracking';

export const submitAction = createAction('google_analytics/submit');

export const submitToGoogleAnalytics =
  ({ payment_type_id }) =>
  (dispatch, getState) => {
    const booking = getState().booking.current;

    // Verify preconditions -> send -> confirm the send happened -> then mark.
    //
    // All three producers of this event route through here (the checkout poll
    // on payment completion, the confirmation view on mount, and the on-account
    // finalise path), so the gate and the one-shot mark live in this shared
    // callee rather than at any single call site (SBAU-611).
    //
    // The paid gate also covers the on-account path for free: touching the
    // booking only means the API accepted the request, and an accepted but
    // unconfirmed on-account booking carries no successful payment yet — so
    // nothing fires and, crucially, no claim is burnt until QuickTravel has
    // actually recorded the payment.
    if (!isBookingPaid(booking)) {
      return;
    }

    // No reference means there is nothing to dedupe on: fire anyway, because
    // losing the purchase event outright is worse than a possible duplicate.
    if (isPurchaseTracked('ga', booking.reference)) {
      return;
    }

    const { client_type_name = null } = getState().user || {};
    const { productTypes } = getState().types;

    // Mangle booking object
    const country = getState().countries?.[booking.country_id]?.name;

    const fillReservationCategory = (reservation) => {
      const productType = productTypes[reservation.product_type_id];

      return { ...reservation, category: productType?.name };
    };

    const annotatedBooking = {
      ...booking,
      country,
      reservations_attributes: booking.reservations_attributes?.map(
        fillReservationCategory
      ),
      payment_type_id,
      client_type_name,
    };

    dispatch(submitAction(annotatedBooking));

    // Mark only once the push has verifiably reached the data layer. If GTM is
    // absent or blocked, sendBookingData reports false and the claim stays
    // untaken, so a later visit can still land the conversion.
    if (GoogleAnalytics.sendBookingData(annotatedBooking)) {
      markPurchaseTracked('ga', booking.reference);
    }
  };
